import { render, staticRenderFns } from "./BaseChecklist.vue?vue&type=template&id=372da555&scoped=true"
import script from "./BaseChecklist.vue?vue&type=script&lang=js"
export * from "./BaseChecklist.vue?vue&type=script&lang=js"
import style0 from "./BaseChecklist.vue?vue&type=style&index=0&id=372da555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372da555",
  null
  
)

export default component.exports